import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/TandaVital";

interface IfcTandaVital {
  id: number;
  register_id: string;
  pasien_rm: string;
  rm_dash: string;
  waktu_periksa: string;
  sistole: number;
  diastole: number;
  frekuensi_nadi: number;
  frekuensi_nafas: number;
  suhu_badan: number;
  saturasi_oksigen: number;
  keadaan_umum: string;
  kesadaran: string;
  map: number;
  unit: {
    id: string;
    nama: string;
  };
  user: {
    id: number;
    nama: string;
  };
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "tanda-vital"
})
class TandaVitalStore extends VuexModule {
  loading = false;
  rawList: Array<IfcTandaVital> = [];
  totalList = 0;

  get list(): Array<IfcTandaVital> {
    return [...this.rawList].sort((a, b) => {
      return (
        new Date(b.waktu_periksa).getTime() -
        new Date(a.waktu_periksa).getTime()
      );
    });
  }

  @Mutation
  SET_RAWLIST(val: [any]) {
    this.rawList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_TOTAL_LIST(val: number) {
    this.totalList = val ?? 0;
  }

  @Mutation
  RESET_STORE() {
    this.rawList = [];
    this.totalList = 0;
  }

  @Action({ rawError: true })
  async getByRegister(regId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(regId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RAWLIST(response.data);
  }

  @Action({ rawError: true })
  async getByRegisterPaginate(params): Promise<void> {
    this.SET_LOADING(true);

    const { page, itemsPerPage, sortBy, sortDesc } = params;
    const param = {
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDesc: sortDesc
    };

    const response = await Service.getByRegister(
      params.registerId,
      param
    ).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RAWLIST(response.data);
    this.SET_TOTAL_LIST(response?.meta.total);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(TandaVitalStore);
